module.exports = __webpack_public_path__ + "img/lectorem_black.29667747.svg";